import {
    ApiClient,
    ApiShopperLandingPage,
    PublicTrackEvents,
} from '@storefronts/common-types'
import { BlackCrowLogger } from './blackcrow'
import { useEffect } from 'react'
import { useTrackingAllowed } from '../components/consent/consentTrackingStore'

type TrackingFn = (e: string, event: CustomEvent) => void

const getTrackingFn = (): TrackingFn => {
    // TODO: do we need this? it doesn't actually do anything
    const fns: TrackingFn[] = []
    return (e: string, event: CustomEvent) => {
        fns.forEach((fn) => fn(e, event))
    }
}

const listenForEvents = (clientHash: string) => {
    const publicTrackEventNames = Object.values(PublicTrackEvents)
    const trackingFn: TrackingFn = getTrackingFn()

    // If queue has events, drain the queue
    if (window.viddyDataLayer.length) {
        while (window.viddyDataLayer.length) {
            const eventObj = window.viddyDataLayer.shift()
            if (eventObj) {
                const { event } = eventObj
                const eventName = event.type

                // Set user Properties
                // These events only used to set properties

                // Log all public & private events
                BlackCrowLogger.logEvent(eventName, event)

                // Only log public events to clients
                if (publicTrackEventNames.includes(eventName)) {
                    trackingFn(eventName, event)
                }
            }
        }
    }

    // Wait a bit before looking for more events
    setTimeout(() => {
        listenForEvents(clientHash)
    }, 200)
}

const initializeViddyAnalytics = async (client: ApiClient) => {
    if (window.viddyAnalyticsLoaded) return

    if (!window.viddyDataLayer) {
        window.viddyDataLayer = []
    }

    // BlackCrow Generic Events Logger
    BlackCrowLogger.initBlackCrow(client)

    BlackCrowLogger.setUserProperties({
        clientHash: client.clientHash,
        clientName: client.name,
    })

    // Listen for events
    listenForEvents(client.clientHash)
    window.viddyAnalyticsLoaded = true
}

export const useAnalytics = (
    landingPage: ApiShopperLandingPage | null | undefined,
    skipPixels: boolean = false,
) => {
    const trackingAllowed = useTrackingAllowed()
    useEffect(() => {
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (!landingPage || skipPixels || !trackingAllowed) return
        initializeViddyAnalytics(landingPage.client)
    }, [landingPage, skipPixels, trackingAllowed])
}
